module.exports = __webpack_public_path__ + "s2.no1.04a959ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s2.no1.jpg
// module id = TqVq
// module chunks = 0